import { CommonModule } from '@angular/common';
import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import type { RCRFeeScheduleResponse } from '../../shared/interfaces/rcrfeescheduleresponse.interface';
import { RecombinationsService } from '../services/recombinations.service';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'invd-fee-schedule',
  templateUrl: './fee-schedule.component.html',
  styleUrls: ['./fee-schedule.component.scss'],
})
export class FeeScheduleComponent implements OnInit {
  /**
   *  variable to hold review data received from back-end (exchangeFeeCalc)
   */
  public rcrFeeScheduleData: RCRFeeScheduleResponse;

  private rcrService = inject(RecombinationsService);

  ngOnInit() {
    //get information saved in shared service to populate this view.
    this.rcrFeeScheduleData = this.rcrService.getFeeScheduleData();
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
